import React, { useContext, useEffect } from 'react'
import { Card, CardContent, Typography, Box, Skeleton } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import { LoadingRecordContext } from 'src/components/pages/sales/reservation/context/LoadingRecordContext'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { useCardId } from 'src/components/pages/sales/reservation/context/CardIdContext'
import { getMediaHeigthCard } from 'src/components/pages/sales/reservation/helper/getMediaHeigthCard'
import { HasPermission } from 'src/helper/HasPermission'
import { useTranslate } from 'react-admin'

export const LeftSideCard = ({ children, style }) => {
  return <div className='cardContentLeftSide' style={style}>{children}</div>
}

export const RigthSideCard = ({ children, style }) => {
  return <div className='cardContentRigthSide' style={style}>{children}</div>
}

export const CompleteSideCard = ({ children, style }) => {
  return (
    <div className='cardContentCompleteSide' style={style}>
      {children}
    </div>
  )
}

export const RowCard = ({ iconHeader, title, blueText, is_titular, children }) => {
  const translate = useTranslate()
  return (
    <div className='row_show_container'>
      <div className='row_show_header'>
        {iconHeader && (
          <Typography sx={{ margin: '0 5px 0 5px', color: blueText ? 'blue' : 'black' }}>
            {iconHeader}
          </Typography>
        )}
        <Typography
          sx={{ margin: '0 5px 0 5px', color: blueText ? 'blue' : 'black' }}
          variant='h7'
          component='div'
          fontWeight={600}
        >
          {title}
        </Typography>

        {is_titular && (
          <Typography
            sx={{ padding: '5px 5px 5px 5px', color: 'white', backgroundColor: 'red', borderRadius: '5px' }}
          >
            {translate('ra.field.holder')}
          </Typography>
        )}
      </div>
      <div className='row_show_content'>{children}</div>
    </div>
  )
}

export const ShowCard = ({
  className,
  iconHeader,
  title,
  posTitle,
  buttonsFlex = 1,
  preActionButton,
  preActionButtonJustify = 'center',
  actionButtonJustify = 'center',
  actionButtonStyle = {},
  actionButtonText,
  actionButtonColor,
  actionButtonStartIcon,
  actionButtonIcon,
  actionButtonLoading = false,
  actionButtonDisabled = false,
  onClickButton,
  headerStyle = {},
  contentStyle = {},
  children,
  cardStyle,
  variant = 'contained',
  optionHeigth = 'contact',
  actionButtonPermissionAction ='hasEdit',
  actionButtonPermissionResource = null,
  avoidPermission = false
}) => {
  const loadingRecord = useContext(LoadingRecordContext)
  const { cardId } = useCardId()
  const { loadingStates, setCardLoading } = useCardLoading()

  const isLoading = loadingStates[cardId]

  useEffect(() => {
    if (!loadingRecord) {
      setCardLoading(cardId, false) // Restablece el estado de carga
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingRecord])

  return (
    <Card className={`showCard ${className || ''}`} style={cardStyle}>
      <CardContent className='cardHeader' style={headerStyle}>
        <Box display={'flex'} alignItems={'center'} flex={2}>
          {iconHeader && <Typography marginRight={2}>{iconHeader}</Typography>}
          <Typography gutterBottom variant='h7' component='div' fontWeight={600}>
            {title}
          </Typography>
          {posTitle && posTitle}
        </Box>
        {(preActionButton || onClickButton) && (
          <Box display={'flex'} flex={buttonsFlex}>
            {preActionButton && (
              <Box flex={4} display={'flex'} alignItems={'center'} justifyContent={preActionButtonJustify}>
                {preActionButton}
              </Box>
            )}

            {onClickButton && (
              <HasPermission resource={actionButtonPermissionResource} permission={actionButtonPermissionAction} skip={avoidPermission}>
                <Box flex={4} display={'flex'} alignItems={'center'} justifyContent={actionButtonJustify}>
                  <LoadingButton
                    loading={actionButtonLoading}
                    variant={variant}
                    disabled={actionButtonDisabled}
                    color={actionButtonColor}
                    onClick={onClickButton}
                    sx={{ width: '90%', ...actionButtonStyle }}
                    startIcon={actionButtonStartIcon}
                    endIcon={actionButtonIcon}
                    size='small'
                  >
                    {actionButtonText}
                  </LoadingButton>
                </Box>
              </HasPermission>
            )}
          </Box>
        )}
      </CardContent>

      <CardContent
        style={isLoading ? { contentStyle, margin: 0, padding: 0 } : contentStyle}
        className='cardContent'
      >
        {isLoading ? (
          <React.Fragment>
            <Skeleton
              animation='wave'
              height={getMediaHeigthCard({ option: optionHeigth })}
              width='100%'
              variant='rectangular'
            />
          </React.Fragment>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  )
}
